import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Radio, Row, Upload } from 'antd'
import { FormItem } from '../../../styles/shared.style'
import { ButtonEx } from '../../../styles/button.style'
import { useDeepEffect } from '../../../utils/hooks'
import { beforeUpload, compressFile, getBase64 } from '../../../utils/services'
import axios from 'axios'

const ProductFeatureForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form
  const [imageUrl, setImageUrl] = useState('')
  const [file, setFile] = useState(null)

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        detail: formData.detail,
        status: formData.enable
      })
      setImageUrl(formData.badge)
    }

    return () => {
      form.resetFields()
      setImageUrl('')
      setFile(null)
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          badge: imageUrl,
          barcodeId: 1, // todo
          detail: values.detail,
          enable: values.status
        }

        try {
          const formImgData = new FormData()
          if (!_.isNull(file)) {
            formImgData.append('image', await compressFile(file))
            const res = await axios.post(
              process.env.REACT_APP_API_ENDPOINT + `/bin/image`,
              formImgData,
              {
                headers: {
                  'content-type': 'multipart/form-data'
                }
              }
            )
            data.badge = res.data.url
          }
        } catch (err) {
          console.log(err)
        }

        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }

        onOk(data)
      }
    })
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  const handleChange = (info) => {
    getBase64(info.file, (imageUrl) => setImageUrl(imageUrl))
  }

  return (
    <Modal
      width={1000}
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} a product feature`}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <FormItem label="Badge">
          {getFieldDecorator(`badge`, {
            rules: [
              {
                required: _.isEmpty(formData),
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Upload
              name="logo"
              listType="picture-card"
              showUploadList={false}
              onChange={handleChange}
              beforeUpload={(file) => beforeUpload(file, setFile)}>
              <Row type="flex" justify="center">
                {imageUrl ? (
                  <img src={imageUrl} alt="avatar" width={100} height={100} />
                ) : (
                  uploadButton
                )}
              </Row>
            </Upload>
          )}
        </FormItem>
        <Form.Item label="Detail">
          {getFieldDecorator(`detail`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Status">
          {getFieldDecorator(`status`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Radio.Group>
              <Radio value={true}>Enabled</Radio>
              <Radio value={false}>Disabled</Radio>
            </Radio.Group>
          )}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

ProductFeatureForm.propTypes = {
  form: PropTypes.any,
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

const WrappedProductFeatureForm = Form.create({ name: 'ProductFeatureForm' })(
  ProductFeatureForm
)
export default WrappedProductFeatureForm



// WEBPACK FOOTER //
// ./src/pages/ProductFeature/ProductFeatureForm/index.js